import { Button, Icon, Link } from '@acpaas-ui/react-components';
import { useState } from 'react';
import ActionsFlyout from '../core/ActionsFlyout';

const DossierSubitemActionBar = ({
  id,
  mailToLink,
  openedClarificationId,
  openedCasetableId,
  onDelete,
  actions,
  canDelete,
  canShare
}) => {
  const [inClipboard, setInClipboard] = useState(false);

  const getLinkToShare = () => {
    const clarificationParam = openedClarificationId ? `clarification=${openedClarificationId}` : '';
    const casetableParam = openedCasetableId ? `casetafel=${openedCasetableId}` : '';
    const joined = [clarificationParam, casetableParam].filter((x) => !!x).join('&');
    return `${window.location.origin}${window.location.pathname}${joined ? `?${joined}` : ''}`;
  };

  const shareActions = [
    {
      name: 'email-link',
      element: (
        <Link className="email-link" href={`${mailToLink}&body=${encodeURIComponent(getLinkToShare())}`}>
          <Icon className="u-margin-right-xs" name="ai-email-action-unread" />
          E-mail
        </Link>
      )
    },
    {
      name: 'clipboard',
      element: (
        <div className="u-flex">
          <Icon className="u-margin-right-xs" name="ai-hyperlink-2" />
          Link kopiëren
          {inClipboard && <Icon className="u-margin-left-auto u-text-success" name="ai-check-1" />}
        </div>
      )
    }
  ].filter((action) => {
    if (!mailToLink && action.name === 'email-link') {
      return false;
    }
    return true;
  });

  const handleActionClick = (action, setIsOpen) => {
    if (action === 'clipboard') {
      navigator.clipboard.writeText(getLinkToShare()).then(() => {
        setInClipboard(true);
        setTimeout(() => setInClipboard(false), 2000);
      });
    }
    if (action === 'email-link') {
      setIsOpen(false);
    }
  };

  return (
    <div className="spo-o-dossier-clarification-details__action-bar">
      <div className="u-margin-right-sm">
        {actions}
        {canShare && <ActionsFlyout label="Delen" actions={shareActions} onActionClick={handleActionClick} />}
      </div>
      {canDelete && (
        <Button
          className="delete-button u-margin-top-sm"
          icon="ai-bin"
          outline
          type="danger"
          onClick={() => onDelete(id)}
        />
      )}
    </div>
  );
};

export default DossierSubitemActionBar;
